import React from 'react';
import type { RecoveryHeldSignoff } from '../../../../shared/admin-recovery-types';

export function HeldSignoffStatus({ status }: { status?: RecoveryHeldSignoff }) {
  if (!status || status.state === 'unavailable') {
    return <section aria-label="Operator signature delivery" className="rounded border p-4">
      <h2 className="font-semibold">Signature delivery status unavailable</h2>
      <p>Refresh the store context before deciding whether another signature is needed.</p>
    </section>;
  }
  if (status.state === 'none') {
    return <section aria-label="Operator signature delivery" className="rounded border p-4">
      <h2 className="font-semibold">No held signature on the server</h2>
      <p>This does not rule out a signature saved on the operator’s phone. Check device sync status before requesting another.</p>
    </section>;
  }
  return <section aria-label="Operator signature delivery" className="rounded border border-amber-300 bg-amber-50 p-4 space-y-2">
    <h2 className="font-semibold">Operator signature received — not finalised</h2>
    <p>The server holds attempt #{status.id}. Do not ask the operator to sign again just because finalisation is pending.</p>
    <p>Captured: <time dateTime={status.capturedAt}>{new Date(status.capturedAt).toLocaleString()}</time>.
      {' '}Received: <time dateTime={status.receivedAt}>{new Date(status.receivedAt).toLocaleString()}</time>.</p>
    <p>{status.incompleteTaskCount > 0
      ? `${status.incompleteTaskCount} task(s) still incomplete on the server. Check outstanding task delivery.`
      : 'No incomplete tasks in this snapshot. Finalisation checks may still be pending.'}</p>
    {!status.promotionEnabled && <p className="font-semibold">Automatic finalisation is paused by configuration.</p>}
    <p>This is delivery status, not approval or authoritative store signoff. Manual retry is not available yet; there is no force-signoff action.</p>
  </section>;
}
